const endPoints = {
    localhost: {
        customerPortalService: 'https://btcustomerportalservice-test.pdc.np.paas.lmig.com',
        apigeeOAuth: 'https://api-tst.us.libertymutual.com/'
    },
    development: {
        customerPortalService: 'https://btcustomerportalservice-dev.pdc.np.paas.lmig.com',
        apigeeOAuth: 'https://api-dev.us.lmig.com/'
    },
    test: {
        customerPortalService: 'https://btcustomerportalservice-test.pdc.np.paas.lmig.com',
        apigeeOAuth: 'https://api-tst.us.libertymutual.com/'
    },
    qa: {
        customerPortalService: 'https://btcustomerportalservice-test.pdc.np.paas.lmig.com',
        apigeeOAuth: 'https://api-tst.us.libertymutual.com/'
    },
    production: {
        customerPortalService: 'https://btcustomerportalservice.pdc.paas.lmig.com',
        apigeeOAuth: 'https://api.us.libertymutual.com/'
    }
};

export default endPoints;



// WEBPACK FOOTER //
// ./src/settings/endPoints.js